// client/src/lib/partnerPipelineStages.js
// Single source of truth for mandate_partner_pipeline.stage on the client —
// mirrors the CHECK constraint (see migrations/056_partner_pipeline_three_stages.sql).
// Array order is the display order. Partnered normally means a signed
// engagement letter; partner advisors already working investors on a
// mandate also count.

export const PARTNER_STAGES = ['To Contact', 'Discussing', 'Partnered']

export const PARTNER_BADGE = {
  'To Contact': 'badge-gray',
  'Discussing': 'badge-yellow',
  'Partnered':  'badge-green',
}
